export default "__VITE_ASSET__DIf8uAOP__"